/**
 * utils 内的 types没必要迁移至此
 */

import React from 'react'
import { EditorFlagEum, LangEum, LocalEum } from '@/constant'
import { IncomingMessage } from 'http'

export { EditorFlagEum, LangEum, LocalEum }

export interface EditConfigType {
  lang?: LangEum
  id?: string
  local?: LocalEum
  editorFlag?: EditorFlagEum
  query?: {
    [key: string]: any
  }
}

export interface GlobalConfigType {
  pinxuanShow: boolean
  style: React.CSSProperties
  // 导航条相关属性
  navigationBackground?: string
  statusBarStyle: 0 | 1
  buttonColor: string
  colorMode: 0 | 1
  hideNavigation: 0 | 1
  //
  [key: string]: any
}

export interface ProviderPropsType {
  dynamicDomain: {
    domain: string
    newDomainUrl: string
  }
  [key: string]: any
}

export type PageStatusType = 'edit' | 'detail' | 'preview'

/** ********************************** component 相关 *************************************************** */

export type ComponentItemPropsType<T = any> = T

export interface ComponentItemType<T = any, D = any> {
  name: string
  props: {
    zh: ComponentItemPropsType<T>
    'zh-TW': ComponentItemPropsType<T>
    'zh-TW2': ComponentItemPropsType<T>
    'zh-MO': ComponentItemPropsType<T>
    en: ComponentItemPropsType<T>
    ja: ComponentItemPropsType<T>
    ko: ComponentItemPropsType<T>
  }
  propsConfig: ComponentItemPropsType<T>
  prefetchData?: PrefetchDataType<D>
  // TODO when add all props, remove any;
  [key: string]: any
}

export interface ShareType {
  icon?: string
  title?: string
  content?: string
}

export interface GlobalConfigType {
  style: React.CSSProperties
  title: string
  share: ShareType
}

export interface FormConfigData {
  componentList: ComponentItemType[]
  globalConfig: GlobalConfigType
  share: ShareType
}

// export type SourceTypes = 'cdn' | 'node'

export enum SourceTypes {
  fromCDN = 'cdn',
  fromNode = 'node',
}

export interface ENVType {
  pageStatus?: PageStatusType
  dataSource: SourceTypes // cdn node
}

export type PrefetchDataType<T = any> = {
  isTrusted: boolean
} & T

// 组件props
export interface BaseComponentItemPropsType<T = any, D = any> {
  propsConfig: T
  globalConfig: GlobalConfigType
  pageId: string
  CName: string
  componentIndex: number
  editConfig: EditConfigType
  providerProps: ProviderPropsType
  prefetchData?: PrefetchDataType<D>
}

export interface AsyncDataFnParamsType<T = any> {
  editConfig: EditConfigType
  req: IncomingMessage
  globalConfig: GlobalConfigType
  propsConfig: T
}

export type PrefetchDataFnType = (params: any) => Promise<any>

// TODO
export interface PrefetchDataMapType {
  [key: string]: PrefetchDataFnType
}

export type LangMapType<T = any> = {
  [K in LangEum]?: T
}

export interface IResponse<T = any> {
  /**
   * 正确响应时该值为 Result#SUCCESS_CODE，错误响应时为错误代码
   */
  code?: number
  data?: T
  /**
   * 正确响应时该值为 Result#DEFAULT_SUCCESS_MESSAGE，错误响应时为错误信息
   */
  msg?: string
  status?: number
}
